import { GENERIC_URL, customAxios } from '../constants';
import { FETCH_AREAS_VENTA } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchAreasVenta() {
  const request = customAxios.post(`${GENERIC_URL}/areaVenta/accesoUsuarioListar`)
  .then(({ data }) => evalAction(data, 'accesoUsuarioListaraccesoUsuarioListar'))
  .catch(error => serverError(error, 'accesoUsuarioListar'));

  return {
    type: FETCH_AREAS_VENTA,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/AreasVenta.js